import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [], // Store the entire API response here
  ip: [],
  senderaccount: [],
  payouts: [],
  payoutlist: []
};

const InitiatepayoutSlice = createSlice({
  name: "Initiatepayout",
  initialState,
  reducers: {
    Initiatepayoutmerchants: (state, action) => {
      state.data = action.payload; // Store the entire API response
    },
    Initiatepayoutmerchants_ip: (state, action) => {
        state.ip = action.payload; // Store the entire API response
    },
    Initiatepayoutmerchants_sender_account: (state, action) => {
        state.senderaccount = action.payload; // Store the entire API response
    },
    Lastpayouts: (state, action) => {
      state.payouts = action.payload; // Store the entire API response
    },
    payouthistry: (state, action) => {
      state.payoutlist = action.payload; // Store the entire API response
    },
  },
});

export const { Initiatepayoutmerchants , Initiatepayoutmerchants_ip , Initiatepayoutmerchants_sender_account , Lastpayouts , payouthistry } = InitiatepayoutSlice.actions;
export default InitiatepayoutSlice.reducer;